import React from "react";

const LogIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M21.9462 6.76099L18.5763 20.291C18.3363 21.301 17.4363 22.001 16.3963 22.001H3.25624C1.74624 22.001 0.666259 20.5209 1.11626 19.0709L5.32625 5.55103C5.61625 4.61103 6.48626 3.96094 7.46626 3.96094H19.7663C20.7163 3.96094 21.5063 4.54094 21.8363 5.34094C22.0263 5.77094 22.0662 6.26099 21.9462 6.76099Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M16.0161 22H20.7961C22.0861 22 23.0961 20.91 23.0061 19.62L22.0161 6"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.6958 6.38049L10.7358 2.06055"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.396 6.39075L17.336 2.05078"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.71631 12H15.7163"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.71631 16H14.7163"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LogIcon;
